// extracted by mini-css-extract-plugin
module.exports = {"kyxLoader":"Loader_kyxLoader__3w2cq","dialog":"Loader_dialog__2x-i8","title":"Loader_title__3iCUw","subtitle":"Loader_subtitle__1HKuC"};